<div id="modal-content-wrapper">
    <header id="modal-header">
        <h4 id="modal-title"><strong>Instructions for finding roof orientation</strong></h4>
    </header>
    <section id="modal-body">
            <p>To find the orientation of the part of the roof that will contain your panels, you'll need to use the drawing tool: </p>

            <video width="500" height="420" autoplay loop>
            <source src="../assets/azimuth.mp4" type="video/mp4" />
            </video>

            <p><strong>Important!</strong> Be sure that your line only contains two points, one at the ridge of your roof, and the other at the bottom of your roof.</p>

    </section>
    <footer id="modal-footer">
        <button mat-flat-button class="okbutton" (click)="closeModal()">Okay, I got it.</button>
    </footer>
</div>
